export class TimerecordService {
  static $inject = ['$resource'];

  private resource: any;

  constructor($resource) {
    this.resource = $resource(
      '/api/timerecords/:id',
      { id: '@id' },
      {
        update: { method: 'PUT' },
        firstIncompleteDay: {
          method: 'GET',
          params: { id: 'firstIncompleteDay' },
        },
      },
    );
  }

  query(...args) {
    return this.resource.query(...args);
  }

  create(timerecord) {
    return new this.resource(timerecord);
  }

  save(...args) {
    return this.resource.save(...args);
  }

  update(...args) {
    return this.resource.update(...args);
  }

  remove(...args) {
    return this.resource.remove(...args);
  }

  firstIncompleteDay({ memberId }) {
    return this.resource.firstIncompleteDay({ memberId }).$promise;
  }
}
